import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {Card} from "reactstrap";
import {Component} from "react";
import * as React from "react";
import './MenuPanel.scss';

/**
 * Panel obsahující menu.
 */
class MenuPanel extends Component {

    static propTypes = {
        children: PropTypes.node
    };

    render() {
        const {children} = this.props;
        return <Card className="items-list bordered menu-panel">
            {children}
        </Card>
    }
}

export default connect()(MenuPanel);
